<template>
  <div id="newsesListPage">
    <NavBar :active="isOnline" class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <v-main class="overflow-hidden">
          <BackBar :title="'اخبار روز'"/>
          <ContentsList :dataLoading="dataLoading" :items="newsList"/>
        </v-main>
      </div>
    </div>
  </div>
</template>

<script>
import ContentsList from "@/components/ContentsList";
import BackBar from "@/components/BackBar";
import NavBar from "@/components/NavBar";

export default {
  name: "NewsesList",
  metaInfo: {
    title: 'ایوان خانه- اخبار',
  },
  components: {NavBar, BackBar, ContentsList},
  data: () => ({
    newsList: [],
    dataLoading: true,
    isOnline: null,
    TypeExtraExtension: null,
  }),
  mounted() {
    if (this.$route.query.isOnline === 'true') {
      this.isOnline = 'online'
      this.TypeExtraExtension = 1
    } else {
      this.isOnline = 'offline'
      this.TypeExtraExtension = 2
    }
    this.getData()
  },
  methods: {
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "Publicly/ListExtraExtension?TypeExtraExtension=" + this.TypeExtraExtension + "&TypeDefineExtraExtension=1", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.newsList = json.list.filter(x => x.IsActive === true)
            this.dataLoading = false
          })
          .catch(error => console.log('error', error));

    }
  }
}
</script>

<style scoped>

</style>
